export default {
    "palette": {
        "primary": {
            "main": "#c06b13",
            "light": "#b68150"
        },
        "secondary": {
            "main": "#173e35"
        },
        "background": {
            "default": "#ffffff"
        },
        "text": {
            "primary": "#000000"
        }
    },
    "typography": {
        "fontFamily": "Raleway",
        "subtitle1": {
            "fontWeight": 700,
            "fontSize": "1.875rem",
            "lineHeight": "1.444"
        },
        "subtitle2": {
            "fontWeight": 700,
            "fontSize": "1.125rem",
            "lineHeight": "1.5"
        },
        "h1": {
            "fontWeight": 700,
            "lineHeight": "1",
            "textTransform": "uppercase",
            "fontSize": "7.25rem",
            "@media (min-width: 0px) and (max-width: 599.5px)": {
                "fontSize": "2.25rem"
            }
        },
        "h2": {
            "fontWeight": 400,
            "fontSize": "4rem",
            "lineHeight": "1",
            "@media (min-width: 0px) and (max-width: 599.5px)": {
                "fontSize": "1.75rem"
            }
        },
        "h3": {
            "fontSize": "3.75rem",
            "fontWeight": 400,
            "lineHeight": "1",
            "@media (min-width: 0px) and (max-width: 599.5px)": {
                "fontSize": "1.6625rem"
            }
        },
        "h5": {
            "fontSize": "2.5rem",
            "lineHeight": "1",
            "fontWeight": 700,
            "@media (min-width: 0px) and (max-width: 599.5px)": {
                "fontSize": "1.225rem"
            }
        },
        "h6": {
            "fontWeight": 400,
            "fontSize": "2.5rem",
            "lineHeight": "1.125",
            "fontStyle": "italic",
            "@media (min-width: 0px) and (max-width: 599.5px)": {
                "fontSize": "1.925rem"
            }
        },
        "h4": {
            "fontSize": "1.625rem",
            "lineHeight": "1.5",
            "@media (min-width: 0px) and (max-width: 599.5px)": {
                "fontSize": "1.125rem"
            }
        },
        "body1": {
            "fontSize": "1.25rem"
        },
        "body2": {
            "fontSize": "0.875rem",
            "lineHeight": "1.7142"
        },
        "overline": {
            "lineHeight": "1.25",
            "textTransform": "uppercase",
            "fontSize": "1.125rem"
        },
        "fontSize": 16,
        "button": {
            "fontSize": "1.125rem",
            "lineHeight": "1.5",
            "fontWeight": 400
        },
        "caption": {
            "fontSize": ".75rem",
            "lineHeight": "1.125",
            "fontWeight": 400
        }
    },
    "googleFonts": [
        "Raleway:100,200,300,regular,500,600,700,800,900,100italic,200italic,300italic,italic,500italic,600italic,700italic,800italic,900italic"
    ]
};